export const isBotpressWorkspace = (workspaceId: string) => {
  return ['95de33eb-1551-4af9-9088-e5dcb02efd09', '6a76fa10-e150-4ff6-8f59-a300feec06c1'].includes(workspaceId)
}
